import { Star24Icon } from '@jablotron/lib.spa-icons/icons/star-24';
import type { ComponentType, SVGProps } from 'react';

/**
 * Slug → icon filename lookup for the mega-menu, maintained alongside the
 * component per the spec. Files live in `public/images/products-mega-menu/`.
 */
const ICON_BASE_PATH = '/images/products-mega-menu';

/** "Produktová řada" column — one small glyph icon per product line slug; title is rendered as live text. */
const LINE_ICON_FILES: Record<string, string> = {
  'jablotron-100-plus': 'line_icon_jablotron-100-plus.svg',
  'jablotron-mercury': 'line_icon_jablotron-mercury.svg',
  nanny: 'line_icon_nanny.svg',
  'mobile-control': 'line_icon_mobile-control.svg',
  'grade-3': 'line_icon_grade-3.svg',
  'software-and-applications': 'line_icon_software-and-applications.svg',
};

/** Slugs rendered with a @jablotron/lib.spa-icons component instead of the static SVG file above. */
const LINE_ICON_COMPONENTS: Record<string, ComponentType<SVGProps<SVGElement>>> = {
  'grade-3': Star24Icon,
};

/** Returns the icon component override for a line slug, if any — takes priority over `getLineIconSrc`. */
export function getLineIconComponent(slug: string): ComponentType<SVGProps<SVGElement>> | undefined {
  return LINE_ICON_COMPONENTS[slug];
}

/** Throws rather than silently falling back — a missing entry here is a broken mapping, not user-facing state. */
function resolveIcon(files: Record<string, string>, slug: string): string {
  const file = files[slug];
  if (!file) {
    throw new Error(`mega-menu: no icon mapped for slug "${slug}"`);
  }

  return `${ICON_BASE_PATH}/${file}`;
}

export function getLineIconSrc(slug: string): string {
  return resolveIcon(LINE_ICON_FILES, slug);
}
